import { ApiTravelerType, ApiPackageDetails } from '@ibe/api';

import React, { JSX } from 'react';

import useTranslation from '../../../../Hooks/useTranslation';
import styled from '../../../../../Styles/theme';

import fallback from '../../../../../_Translations/generated/PackagePrice.en.t.json';
import Keys from '../../../../../_Translations/generated/PackagePrice.en.t.json.keys';
import { Price } from '../../../../Components/UI/Price/Price';

const StyledPrice = styled(Price)(props => ({
  color: props.theme.bootstrap.primary,
  fontSize: '1.5rem',
  lineHeight: '2rem'
}));

export interface PackagePriceProps {
  detail: ApiPackageDetails;
}

const PackagePrice = (props: PackagePriceProps): JSX.Element => {
  const { t } = useTranslation('package-price', fallback, Keys);
  const { detail } = props;
  const price = detail.priceDetails.find(d => d.travelerType === ApiTravelerType.ADULT)?.price;

  return (
    <div>
      <div>{t(Keys.startingAt)}</div>

      {/* TODO api price can not be undefined */}
      {price && (
        <div>
          <StyledPrice displayInline price={price} />
          {t(Keys.perAdult)}
        </div>
      )}
      <div className="small">{t(Keys.priceInfo)}</div>
    </div>
  );
};
export default PackagePrice;
